import React, { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import "./LabReport.css"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { createPortal } from "react-dom";
const AddTestParam = ({ item, onAddDepart }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [serverSlotIds, setServerSlotIds] = useState([]);
  

  const [showFormulaModal, setShowFormulaModal] = useState(false);
  const [formulaParamIndex, setFormulaParamIndex] = useState(null);
  const [formulaText, setFormulaText] = useState('');   // editable source of truth
  const [formulaSearch, setFormulaSearch] = useState('');
  const [formulaNum, setFormulaNum] = useState('');
  // Items state
  const [itemOptions, setItemOptions] = useState([]);
  const [currentParamIndex, setCurrentParamIndex] = useState(null);
  const [showItemsModal, setShowItemsModal] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);

  const emptyParam = {
    id: Date.now(),
    test_param_id: '',
    test_param_name: '',
    test_param_type: 'Numeric',
    test_range_type: '',
    test_param_gender: '',
    test_param_result_type: 'Dropdown',
    test_param_from_range: '',
    test_param_to_range: '',
    test_param_units: '',
    test_param_method: '',
    test_param_inter: '',
    test_param_user: '',
    test_param_formula: '',
    selectedItems: [],
  };

  const initialFormState = {
    cats: [],
    tests: [],
    test_cat: '',
    test_id: '',
    items: [ { ...emptyParam } ],
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [ldata, setLdata] = useState(null);

  // Fetch items on mount - FIXED
  const fetchItems = async () => {
    setItemsLoading(true);
    try {
      // REMOVE FormData - GET requests don't use request body
      const res = await axios.get(AppConst.BASE_URL + AppConst.itemListUrl);
      
      console.log("Raw API response:", res.data); // Debug
      
      if (res.data.status) {
        const itemsData = res.data.records || res.data.data || [];
        console.log("Items data array:", itemsData); // Debug
        
        const options = itemsData.map(item => ({
          value: item.store_item_id || item.id,
          label: `${item.store_hsn || ''} - ${item.store_item_name || item.name || ''} (${item.store_unit || ''})`.trim(),
          data: item
        }));
        
        console.log("Mapped options:", options); // Debug
        setItemOptions(options);
        return options;
      } else {
        console.warn("Items fetch returned no records");
        return [];
      }
    } catch (err) {
      console.error("Item fetch error:", err);
      toast.error("Failed to load items");
      return [];
    } finally {
      setItemsLoading(false);
    }
  };


// ---- formula serialize/deserialize ----
const serializeFormula = (tokens) =>
  tokens.map(t => (t.type === 'param' ? `{${t.id}}` : t.value)).join(' ');

const deserializeFormula = (str, itemsForNames) => {
  if (!str) return [];
  const tokens = [];
  const regex = /\{(\d+)\}|([+\-*/()])|(\d+(?:\.\d+)?)/g;
  let m;
  while ((m = regex.exec(str)) !== null) {
    if (m[1]) {
      const p = (itemsForNames || []).find(it => String(it.test_param_id) === String(m[1]));
      tokens.push({ type: 'param', id: m[1], name: p ? p.test_param_name : `#${m[1]}` });
    } else if (m[2]) {
      tokens.push({ type: 'op', value: m[2] });
    } else if (m[3]) {
      tokens.push({ type: 'num', value: m[3] });
    }
  }
  return tokens;
};
// parse "{277} + {278} = {279}" into tokens (for the name preview only)
const parseFormula = (str, itemsForNames) => {
  if (!str) return [];
  const tokens = [];
  const regex = /\{(\d+)\}|([+\-*/()=])|(\d+(?:\.\d+)?)/g;
  let m;
  while ((m = regex.exec(str)) !== null) {
    if (m[1]) {
      const p = (itemsForNames || []).find(it => String(it.test_param_id) === String(m[1]));
      tokens.push({ type: 'param', id: m[1], name: p ? p.test_param_name : `#${m[1]}` });
    } else if (m[2]) {
      tokens.push({ type: 'op', value: m[2] });
    } else if (m[3]) {
      tokens.push({ type: 'num', value: m[3] });
    }
  }
  return tokens;
};

// append into the editable text, keeping single spaces
const appendToFormula = (str) =>
  setFormulaText(prev => {
    const base = prev.trimEnd();
    return (base.length ? base + ' ' : '') + str + ' ';
  });

const addParamToFormula = (p) => appendToFormula(`{${p.test_param_id}}`);
const addOpToFormula   = (op) => appendToFormula(op);
const addEqualsToFormula = () => appendToFormula('=');
const addNumToFormula = () => {
  if (String(formulaNum).trim() === '') return;
  appendToFormula(String(formulaNum).trim());
  setFormulaNum('');
};



// one request → both reagents and formula
const fetchParamMeta = async (test_param_id, availableOptions = null) => {
  const options = availableOptions || itemOptions;
  const fd = new FormData();
  fd.append('test_param_id', test_param_id);
  let selectedItems = [];
  let formula = '';
  try {
    const res = await axios.post(AppConst.BASE_URL + AppConst.getTestParamItemsUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (res.data.status) {
      if (res.data.items && res.data.items.length > 0 && options && options.length) {
        const itemIds = res.data.items.map(i => String(i.store_item_id));
        selectedItems = options.filter(opt => itemIds.includes(String(opt.value)));
      }
      formula = res.data.formula || '';
    }
  } catch (err) {
    console.error('fetchParamMeta error', err);
  }
  return { selectedItems, formula };
};

// ---- formula popup handlers ----
const handleOpenFormulaPopup = async (index) => {
  const param = formData.items[index];
  let formulaStr = param.test_param_formula || '';

  if (!formulaStr && param.test_param_id) {
    const meta = await fetchParamMeta(param.test_param_id);   // from previous step
    formulaStr = meta.formula;
    setFormData(prev => {
      const items = [...prev.items];
      items[index] = { ...items[index], test_param_formula: formulaStr };
      return { ...prev, items };
    });
  }

  setFormulaText(formulaStr);
  setFormulaSearch('');
  setFormulaNum('');
  setFormulaParamIndex(index);
  setShowFormulaModal(true);
};

const handleSaveFormula = async () => {
  if (formulaParamIndex === null) return;
  const param = formData.items[formulaParamIndex];
  const formulaStr = formulaText.trim();

  // reflect locally so button flips Add -> Edit immediately
  setFormData(prev => {
    const items = [...prev.items];
    items[formulaParamIndex] = { ...items[formulaParamIndex], test_param_formula: formulaStr };
    return { ...prev, items };
  });

  if (!param.test_param_id) {
    toast.info("Save the parameter first, then the formula will be stored");
    setShowFormulaModal(false);
    return;
  }

  const fd = new FormData();
  fd.append('test_param_id', param.test_param_id);
  fd.append('test_id', formData.test_id);
  fd.append('formula', formulaStr);
  try {
    const res = await axios.post(AppConst.BASE_URL + AppConst.saveTestParamItemsUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (res.data.status) {
      toast.success("Formula saved");
      setShowFormulaModal(false);
    } else {
      toast.error(res.data.success || "Failed to save formula");
    }
  } catch (err) {
    console.error("Save formula error:", err);
    toast.error("Server error");
  }
};

  // Call on mount
  useEffect(() => {
    fetchItems();
  }, []);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const addItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [
        ...prev.items,
        {
          ...emptyParam,
          id: Date.now() + Math.floor(Math.random()*1000),
          selectedItems: []
        }
      ]
    }));
  };

  const delItem = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, index) => index !== indexToRemove)
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChange1 = (e, index) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedItems = [...prev.items];
      updatedItems[index] = {
        ...updatedItems[index],
        [name]: value
      };
      return {
        ...prev,
        items: updatedItems
      };
    });
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    const newItems = reorder(formData.items, result.source.index, result.destination.index);
    setFormData(prev => ({ ...prev, items: newItems }));
  };

  const fetchTestParams = async (testId) => {
    if (!testId) return;
    const fd = new FormData();
    fd.append('test_id', testId);
    fd.append('page_no', "none");
    
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTestParamListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.status) {
        const records = response.data.records || [];
        
        // Ensure itemOptions is loaded
        let options = itemOptions;
        if (!options || options.length === 0) {
          options = await fetchItems();
        }
        
        // Fetch items for each param
        const mappedPromises = records.map(async (r, idx) => {
          let selectedItems = [];
          let formulaStr = '';
          if (r.test_param_id) {
            try {
              const meta = await fetchParamMeta(r.test_param_id, options);
              selectedItems = meta.selectedItems;
              formulaStr    = meta.formula;
            } catch (err) {
              console.error("Error fetching meta for param:", r.test_param_id, err);
            }
          }
        
          return {
            id: r.test_param_id ? `srv-${r.test_param_id}` : Date.now() + idx,
            test_param_id: r.test_param_id || '',
            test_param_name: r.test_param_name || '',
            test_param_type: r.test_param_type || 'Numeric',
            test_range_type: r.test_range_type || '',
            test_param_gender: r.test_param_gender || '',
            test_param_result_type: r.test_param_result_type || 'Dropdown',
            test_param_from_range: r.test_param_from_range || '',
            test_param_to_range: r.test_param_to_range || '',
            test_param_units: r.test_param_units || '',
            test_param_method: r.test_param_method || '',
            test_param_inter: r.test_param_inter || '',
            test_param_user: r.test_param_user || '',
            test_param_formula: formulaStr,   // <-- now actually filled
            selectedItems: selectedItems,
          };
        });

        const mapped = await Promise.all(mappedPromises);
        setFormData(prev => ({ ...prev, items: mapped }));
        
        const slotIds = records.map(r => String(r.test_param_id));
        setServerSlotIds(slotIds);
        
        return mapped;
      }
    } catch (error) {
      console.error("fetchTestParams error", error);
    }
  };

  const fetchParamItems = async (test_param_id, availableOptions = null) => {
    if (!test_param_id) return [];
    
    const options = availableOptions || itemOptions;
    if (!options || options.length === 0) {
      console.warn("No item options available");
      return [];
    }
    
    const fd = new FormData();
    fd.append('test_param_id', test_param_id);
    
    try {
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getTestParamItemsUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (res.data.status && res.data.items && res.data.items.length > 0) {
        const itemIds = res.data.items.map(i => String(i.store_item_id));
        const selected = options.filter(opt => itemIds.includes(String(opt.value)));
        console.log("Fetched param items:", selected); // Debug
        return selected;
      }
    } catch (err) {
      console.error("Fetch param items error:", err);
    }
    return [];
  };

  const handleOpenItemsPopup = async (index) => {
    // Ensure items are loaded
    if (!itemOptions || itemOptions.length === 0) {
      await fetchItems();
    }
    
    // If parameter has test_param_id, fetch its items
    const param = formData.items[index];
    if (param.test_param_id && (!param.selectedItems || param.selectedItems.length === 0)) {
      const items = await fetchParamItems(param.test_param_id);
      if (items.length > 0) {
        setFormData(prev => {
          const updatedItems = [...prev.items];
          updatedItems[index] = {
            ...updatedItems[index],
            selectedItems: items
          };
          return { ...prev, items: updatedItems };
        });
      }
    }
    
    setCurrentParamIndex(index);
    setShowItemsModal(true);
  };

  const handleSaveItems = async () => {
    if (currentParamIndex === null) return;
    
    const param = formData.items[currentParamIndex];
    
    // If no test_param_id, just save locally
    if (!param.test_param_id) {
      toast.info("Save the parameter first, then items will be saved to database");
      setShowItemsModal(false);
      return;
    }

    const fd = new FormData();
    fd.append('test_param_id', param.test_param_id);
    fd.append('items', JSON.stringify((param.selectedItems || []).map(i => i.value)));

    try {
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.saveTestParamItemsUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (res.data.status) {
        toast.success("Items saved successfully");
        setShowItemsModal(false);
      } else {
        toast.error(res.data.success || "Failed to save items");
      }
    } catch (err) {
      console.error("Save items error:", err);
      toast.error("Server error");
    }
  };

  const handleDeleteParam = async (test_param_id, index) => {
    if (!test_param_id) {
      delItem(index);
      return;
    }

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the parameter.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    const fd = new FormData();
    fd.append('test_param_id', test_param_id);
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delTestParamUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.status) {
        setFormData(prev => ({
          ...prev,
          items: prev.items.filter((_, i) => i !== index)
        }));
        Swal.fire({ title: 'Deleted', text: 'Parameter deleted', icon: 'success', timer: 1200, showConfirmButton: false });
      } else {
        Swal.fire({ title: 'Error', text: response.data.success || 'Delete failed', icon: 'error' });
      }
    } catch (error) {
      console.error("handleDeleteParam error", error);
      Swal.fire({ title: 'Error', text: 'Delete failed (network)', icon: 'error' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const itemsToSend = formData.items.map((it, idx) => {
      const targetId = (serverSlotIds && serverSlotIds[idx]) ? serverSlotIds[idx] : (it.test_param_id || '');
      return { ...it, target_id: targetId, order: idx };
    });
  
    const fd = new FormData();
    fd.append('items', JSON.stringify(itemsToSend));
    fd.append('test_id', formData.test_id);
    fd.append('test_cat', formData.test_cat);
    fd.append('test_user', ldata?.user_id || '');
  
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addTestParamUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  
      if (response.data.status) {
        const debug = response.data.debug || [];
        const updatedItems = [...formData.items];
        
        if (Array.isArray(debug) && debug.length > 0) {
          debug.forEach(d => {
            const idx = typeof d.index === 'number' ? d.index : null;
            if (idx !== null && idx >= 0 && idx < updatedItems.length) {
              if (d.row_after) {
                updatedItems[idx] = {
                  ...updatedItems[idx],
                  test_param_id: String(d.row_after.test_param_id ?? updatedItems[idx].test_param_id ?? ''),
                  test_param_name: d.row_after.test_param_name ?? updatedItems[idx].test_param_name,
                  test_param_type: d.row_after.test_param_type ?? updatedItems[idx].test_param_type,
                  test_range_type: d.row_after.test_range_type ?? updatedItems[idx].test_range_type,
                  test_param_from_range: d.row_after.test_param_from_range ?? updatedItems[idx].test_param_from_range,
                  test_param_to_range: d.row_after.test_param_to_range ?? updatedItems[idx].test_param_to_range,
                  test_param_units: d.row_after.test_param_units ?? updatedItems[idx].test_param_units,
                  test_param_method: d.row_after.test_param_method ?? updatedItems[idx].test_param_method,
                  test_param_inter: d.row_after.test_param_inter ?? updatedItems[idx].test_param_inter,
                };
              } else if (d.insertedId) {
                updatedItems[idx] = { ...updatedItems[idx], test_param_id: String(d.insertedId) };
              }
            }
          });
          setFormData(prev => ({ ...prev, items: updatedItems }));
          
          // Save items for newly created params
          for (let i = 0; i < updatedItems.length; i++) {
            const it = updatedItems[i];
            if (it.test_param_id && it.selectedItems && it.selectedItems.length > 0) {
              try {
                const fd2 = new FormData();
                fd2.append('test_param_id', it.test_param_id);
                fd2.append('items', JSON.stringify(it.selectedItems.map(si => si.value)));
                await axios.post(AppConst.BASE_URL + AppConst.saveTestParamItemsUrl, fd2, {
                  headers: { 'Content-Type': 'multipart/form-data' }
                });
              } catch (err) {
                console.error("Failed to save items for param:", it.test_param_id, err);
              }
            }
          }


          // Save formulas for params (existing + newly created)
for (let i = 0; i < updatedItems.length; i++) {
  const it = updatedItems[i];
  if (it.test_param_id && it.test_param_formula && it.test_param_formula.length > 0) {
    try {
      const fd3 = new FormData();
      fd3.append('test_param_id', it.test_param_id);
      fd3.append('test_id', formData.test_id);
      fd3.append('formula', it.test_param_formula);
      await axios.post(AppConst.BASE_URL + AppConst.saveTestParamItemsUrl, fd3, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    } catch (err) {
      console.error("Failed to save formula for param:", it.test_param_id, err);
    }
  }
}
        }
  
        if (onAddDepart) {
          try { onAddDepart(updatedItems); } catch (err) { onAddDepart(); }
        }
  
        Swal.fire({ title: 'Saved', text: response.data.success || 'Parameters saved', icon: 'success', timer: 1400, showConfirmButton: false });
        document.getElementById("closeBt45")?.click();
  
        setSearchTerm('');
        setShowDropdown(false);
        setFormData(prev => ({ ...prev, items: [{ ...emptyParam, id: Date.now(), selectedItems: [] }], test_id: '', test_cat: '' }));
        setServerSlotIds([]);
      } else {
        Swal.fire({ title: 'Error', text: response.data.success || 'Save failed', icon: 'error' });
      }
    } catch (error) {
      console.error("save error", error);
      Swal.fire({ title: 'Error', text: 'Save failed (network)', icon: 'error' });
    }
  };

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const fd = new FormData();
      fd.append('cat_type', "department");
      fd.append('page_no', "none");
      fd.append('search_key', "");
      fd.append('par_by', "1");
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({ ...prev, cats: records }));
          }
        }
      } catch (error) {
        console.error("getCatList error", error);
      }
    }
  };

  const getTests = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const fd1 = new FormData();
      fd1.append('page_no', "none");
      fd1.append('search_key', "");
      fd1.append('test_user', "1");
      fd1.append('test_cat', formData.test_cat + "");
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd1, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({ ...prev, tests: records }));
          }
        }
      } catch (error) {
        console.error("getTestList error", error);
      }
    }
  };

  useEffect(() => { getTests(); }, [formData.test_cat]);

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }

    if (item) {
      if (item.test_param_parent) {
        setFormData(prev => ({ ...prev, test_cat: item.test_cat || '', test_id: item.test_param_parent }));
        fetchTestParams(item.test_param_parent);
      } else {
        var itms = [ { 
          ...emptyParam, 
          id: Date.now(), 
          test_param_id: item.test_param_id, 
          test_param_name: item.test_param_name, 
          test_param_type: item.test_param_type, 
          test_range_type: item.test_range_type, 
          test_param_gender: item.test_param_gender, 
          test_param_result_type: item.test_param_result_type, 
          test_param_from_range: item.test_param_from_range, 
          test_param_to_range: item.test_param_to_range, 
          test_param_units: item.test_param_units, 
          test_param_method: item.test_param_method, 
          test_param_inter: item.test_param_inter, 
          test_param_user: item.test_param_user,
          selectedItems: []
        } ];
        setFormData(prev => ({ ...prev, items: itms, test_cat: item.test_cat, test_id: item.test_param_parent || '' }));
      }
    } else {
      setFormData(prev => ({ ...prev, items: [ { ...emptyParam, id: Date.now(), selectedItems: [] } ] }));
    }
  }, [item]);

  useEffect(() => {
    const modalEl = document.getElementById('showModal');
    if (!modalEl) return;
    const handleShow = () => {
      if (!item) {
        setSearchTerm('');
        setShowDropdown(false);
        setFormData(prev => ({ ...prev, test_id: '', test_cat: '', items: [ { ...emptyParam, id: Date.now(), selectedItems: [] } ] }));
      }
    };
    modalEl.addEventListener('show.bs.modal', handleShow);
    return () => modalEl.removeEventListener('show.bs.modal', handleShow);
  }, [item]);

  const dragHandleStyle = { cursor: 'grab' };

  return (
    <>
<div 
  className="modal fade exampleModalFullscreen" 
  id="showModal" 
  tabIndex="-1" 
  aria-labelledby="exampleModalLabel" 
  aria-hidden="true"
  data-bs-focus="false"
>
        <div className="modal-dialog modal-xl modal-dialog-centered" role="document" style={{ maxWidth: '95vw' }}>
          <div className="modal-content" style={{ height: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div className="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
              <h5 className="modal-title" id="exampleModalLabel">Add Parameter</h5>
              <button type="button" className="btn btn-sm btn-outline-primary" data-bs-dismiss="modal" id="close-modal">Close</button>
            </div>

            <form className="tablelist-form" onSubmit={handleSubmit} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <div className="modal-body" style={{ overflowY: 'auto', paddingBottom: 12, flex: '1 1 auto' }}>
                <div className="row gy-4 mb-3">
                  <div className="col-md-6" style={{ position: "relative" }}>
                    <label className="form-label">Test</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search or select Test"
                      value={
                        searchTerm ||
                        formData.tests.find((t) => String(t.test_id) === String(formData.test_id))?.test_name ||
                        ""
                      }
                      onFocus={() => setShowDropdown(true)}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearchTerm(value);
                        setFormData(prev => ({ ...prev, test_id: '' }));
                      }}
                      autoComplete="off"
                      required
                    />
                    {showDropdown && (
                      <ul className="list-group" style={{ position: "absolute", zIndex: 3000, width: "100%", maxHeight: "220px", overflowY: "auto", cursor: "pointer" }}>
                        {formData.tests.filter((item) => item.test_name.toLowerCase().includes(searchTerm.toLowerCase())).map((t, index) => (
                          <li key={index} className="list-group-item list-group-item-action" onClick={() => { setFormData(prev => ({ ...prev, test_id: t.test_id })); setSearchTerm(t.test_name); setShowDropdown(false); if (!item) fetchTestParams(t.test_id); }}>
                            {t.test_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="col-md-8"></div>
                  <div className="col-md-4" style={{ textAlign: "right" }}>
                    <button type="button" onClick={addItem} className="btn btn-success">Add Row</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button type="submit" className="btn btn-primary" id="edit-btn">Save</button>
                  </div>

                  <div className="col-md-12">
                    <div className="table-responsive" style={{ overflowY: 'auto' }}>
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="params-droppable">
                          {(provided) => (
                            <table className="table table-bordered table-striped" ref={provided.innerRef} {...provided.droppableProps}>
                              <thead className="table-light">
                                <tr>
                                  <th style={{ width: 40 }}>↕</th>
                                  <th>#</th>
                                  <th>Parameter</th>
                                  <th>Unit</th>
                                  <th>Type</th>
                                  <th>Range / Details</th>
                                  <th>To Range</th>
                                  <th>Method</th>
                                  <th>Formula</th>
                                  <th>Reagent</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {formData.items.map((it, index) => (
                                  <Draggable key={String(it.id)} draggableId={String(it.id)} index={index}>
                                    {(prov, snapshot) => (
                                      <React.Fragment>
                                        <tr
                                          ref={prov.innerRef}
                                          {...prov.draggableProps}
                                          style={{
                                            ...prov.draggableProps.style,
                                            background: snapshot.isDragging ? '#f8f9fa' : undefined
                                          }}
                                        >
                                          <td {...prov.dragHandleProps} style={dragHandleStyle} className="align-middle text-center">☰</td>
                                          <td className="align-middle">{index + 1}</td>
                                          <td className="align-middle">
                                            <input name="test_param_name" onChange={(e) => handleChange1(e, index)} value={it.test_param_name} className="form-control" placeholder="Enter Parameter" type="text" required />
                                          </td>
                                          <td className="align-middle">
                                            {it.test_param_type === "Editor" ? (
                                              <input className="form-control" value="N/A" disabled readOnly />
                                            ) : (
                                              <input name="test_range_type" onChange={(e) => handleChange1(e, index)} value={it.test_range_type} className="form-control" placeholder="Unit" type="text" />
                                            )}
                                          </td>
                                          <td className="align-middle">
                                            <select className="form-control" name="test_param_type" onChange={(e) => handleChange1(e, index)} value={it.test_param_type} required>
                                              <option value="">Select</option>
                                              <option value="Numeric">Numeric</option>
                                              <option value="Text">Text</option>
                                              <option value="Boolean">Boolean</option>
                                              <option value="Editor">Editor</option>
                                            </select>
                                          </td>
                                          <td className="align-middle">
                                            {it.test_param_type === "Numeric" ? (
                                              <input name="test_param_from_range" onChange={(e) => handleChange1(e, index)} value={it.test_param_from_range} className="form-control" placeholder="From" type="number" />
                                            ) : it.test_param_type === "Boolean" ? (
                                              <select className="form-control" name="test_param_from_range" onChange={(e) => handleChange1(e, index)} value={it.test_param_from_range}><option value="">Select</option><option value="Yes">Yes</option><option value="No">No</option></select>
                                            ) : it.test_param_type === "Editor" ? (
                                              <span className="text-muted">Shown below</span>
                                            ) : (
                                              <textarea className="form-control" name="test_param_from_range" onChange={(e) => handleChange1(e, index)} value={it.test_param_from_range} placeholder="Enter Range" />
                                            )}
                                          </td>
                                          <td className="align-middle">
                                            {it.test_param_type === "Numeric" ? (
                                              <input name="test_param_to_range" onChange={(e) => handleChange1(e, index)} value={it.test_param_to_range} className="form-control" placeholder="To" type="number" />
                                            ) : <span className="text-muted">N/A</span>}
                                          </td>
                                          <td className="align-middle">
                                            {it.test_param_type !== "Editor" ? (
                                              <input name="test_param_method" onChange={(e) => handleChange1(e, index)} value={it.test_param_method} className="form-control" placeholder="Method" type="text" />
                                            ) : <span className="text-muted">N/A</span>}
                                          </td>
                                          

                                            {/* FORMULA COLUMN */}
<td className="align-middle text-center">
  <button
    type="button"
    className={`btn btn-sm ${it.test_param_formula && it.test_param_formula.length > 0 ? 'btn-warning' : 'btn-primary'}`}
    onClick={() => handleOpenFormulaPopup(index)}
  >
    {it.test_param_formula && it.test_param_formula.length > 0 ? 'Edit' : 'Add'}
  </button>
</td>




                                          {/* ITEMS COLUMN */}
                                          <td className="align-middle text-center">
                                            <button
                                              type="button"
                                              className={`btn btn-sm ${it.selectedItems && it.selectedItems.length > 0 ? 'btn-warning' : 'btn-info'}`}
                                              onClick={() => handleOpenItemsPopup(index)}
                                            >
                                              {it.selectedItems && it.selectedItems.length > 0 ? 'Update' : 'Add'}
                                              {it.selectedItems && it.selectedItems.length > 0 && ` (${it.selectedItems.length})`}
                                            </button>
                                          </td>

                                          <td className="align-middle">
                                            {it.test_param_id && String(it.test_param_id).length > 0 ? (
                                              <div style={{ display: 'flex', gap: 6 }}>
                                                <button type="button" onClick={() => handleDeleteParam(it.test_param_id, index)} className="btn btn-sm btn-danger">Delete</button>
                                              </div>
                                            ) : (
                                              <button type="button" onClick={() => delItem(index)} className="btn btn-sm btn-danger">Remove</button>
                                            )}
                                          </td>
                                        </tr>

                                        {it.test_param_type === "Editor" && (
                                          <tr>
                                            <td colSpan="11">
                                              <CKEditor editor={ClassicEditor} data={it.test_param_from_range} onChange={(event, editor) => {
                                                const data = editor.getData();
                                                const fakeEvent = { target: { name: 'test_param_from_range', value: data } };
                                                handleChange1(fakeEvent, index);
                                              }} />
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </tbody>
                            </table>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>

                </div>
              </div>

              <div className="modal-footer" style={{ flexShrink: 0 }}>
                <div className="hstack gap-2 justify-content-end" style={{ width: '100%' }}>
                  <button type="button" id="closeBt45" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


      {showFormulaModal && formulaParamIndex !== null && createPortal(
  <div
    className="modal fade show"
    style={{
      display: 'block', backgroundColor: 'rgba(0,0,0,0.5)',
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 99999, overflow: 'auto'
    }}
    onClick={(e) => { if (e.target === e.currentTarget) setShowFormulaModal(false); }}
  >
    <div
      className="modal-dialog modal-dialog-centered modal-lg"
      style={{ position: 'relative', zIndex: 100000 }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-content">
        <div className="modal-header bg-soft-primary p-3">
          <h5 className="modal-title">
            Formula — {formData.items[formulaParamIndex]?.test_param_name || 'Parameter'}
          </h5>
          <button type="button" className="btn-close"
            onClick={(e) => { e.preventDefault(); setShowFormulaModal(false); }} />
        </div>

        <div className="modal-body" style={{ minHeight: '340px' }}>
          {/* EDITABLE formula field */}
          <label className="form-label">Formula (editable)</label>
          <textarea
            className="form-control mb-2"
            rows={2}
            value={formulaText}
            onChange={(e) => setFormulaText(e.target.value)}
            placeholder="e.g.  {277} + {278} = {279}"
            style={{ fontFamily: 'monospace' }}
          />
          <small className="text-muted d-block mb-2">
            Use <code>{'{id}'}</code> for a parameter, then <code>=</code> to set the destination param.
            Example: <code>Neutrophil + Lymphocyte = Monocyte</code>.
          </small>

          {/* live name preview */}
          <div className="border rounded p-2 mb-3" style={{ minHeight: 44, background: '#f8f9fb' }}>
            {parseFormula(formulaText, formData.items).length === 0 ? (
              <span className="text-muted">Preview will appear here…</span>
            ) : (
              parseFormula(formulaText, formData.items).map((t, i) => (
                <span
                  key={i}
                  className={`badge me-1 mb-1 ${
                    t.type === 'param' ? 'bg-info'
                    : t.type === 'num' ? 'bg-secondary'
                    : t.value === '=' ? 'bg-success'
                    : 'bg-dark'
                  }`}
                  style={{ fontSize: 13 }}
                >
                  {t.type === 'param' ? `${t.name} (#${t.id})` : t.value}
                </span>
              ))
            )}
          </div>

          {/* operators + equals + constant */}
          <div className="mb-3 d-flex align-items-center flex-wrap gap-1">
            {['+', '-', '*', '/', '(', ')'].map(op => (
              <button key={op} type="button" className="btn btn-sm btn-light border"
                onClick={() => addOpToFormula(op)}>{op}</button>
            ))}
            <button type="button" className="btn btn-sm btn-success" onClick={addEqualsToFormula}>=</button>
            <input
              type="number"
              className="form-control form-control-sm ms-2"
              style={{ width: 110 }}
              placeholder="number"
              value={formulaNum}
              onChange={(e) => setFormulaNum(e.target.value)}
            />
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={addNumToFormula}>Add #</button>
          </div>

          {/* parameter picker (only saved params of this test) */}
          <label className="form-label">Test Parameters</label>
          <input
            className="form-control mb-2"
            placeholder="Search parameter..."
            value={formulaSearch}
            onChange={(e) => setFormulaSearch(e.target.value)}
          />
          <div className="border rounded" style={{ maxHeight: 200, overflowY: 'auto' }}>
            {(() => {
              const pickable = formData.items.filter(
                it => it.test_param_id && String(it.test_param_id).length > 0 &&
                  (it.test_param_name || '').toLowerCase().includes(formulaSearch.toLowerCase())
              );
              if (pickable.length === 0) {
                return <div className="p-2 text-muted">No saved parameters to reference. Save the parameters first.</div>;
              }
              return pickable.map(p => (
                <div
                  key={p.test_param_id}
                  className="d-flex justify-content-between p-2 border-bottom"
                  style={{ cursor: 'pointer' }}
                  onClick={() => addParamToFormula(p)}
                >
                  <span>{p.test_param_name}</span>
                  <span className="text-muted">#{p.test_param_id}</span>
                </div>
              ));
            })()}
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-light"
            onClick={(e) => { e.preventDefault(); setShowFormulaModal(false); }}>Cancel</button>
          <button type="button" className="btn btn-success"
            onClick={(e) => { e.preventDefault(); handleSaveFormula(); }}>Save Formula</button>
        </div>
      </div>
    </div>
  </div>,
  document.body
)}


{/* Items Popup Modal - PORTAL VERSION */}
{showItemsModal && currentParamIndex !== null && createPortal(
  <div 
    className="modal fade show" 
    style={{ 
      display: 'block', 
      backgroundColor: 'rgba(0,0,0,0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999,  // ✅ Higher than parent modal (Bootstrap default is 1055)
      overflow: 'auto'
    }}
    onClick={(e) => {
      // Close only when clicking outside the dialog
      if (e.target === e.currentTarget) {
        setShowItemsModal(false);
      }
    }}
  >
    <div 
      className="modal-dialog modal-dialog-centered modal-lg" 
      style={{ position: 'relative', zIndex: 100000 }}  // ✅ Even higher
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-content">
        <div className="modal-header bg-soft-info p-3">
          <h5 className="modal-title">
            Select Reagents - {formData.items[currentParamIndex]?.test_param_name || 'Parameter'}
          </h5>
          <button 
            type="button" 
            className="btn-close" 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowItemsModal(false);
            }}
          ></button>
        </div>
        <div className="modal-body" style={{ minHeight: '300px' }}>
          {itemsLoading ? (
            <div className="text-center">Loading items...</div>
          ) : (
            <>
              <div className="mb-3">
                <label className="form-label">Select Items (Multiple)</label>
                
                <div className="alert alert-info mb-2" style={{ fontSize: '12px' }}>
                  Available Items: {itemOptions.length} | Selected: {formData.items[currentParamIndex]?.selectedItems?.length || 0}
                </div>

                <Select
                  isMulti
                  value={formData.items[currentParamIndex]?.selectedItems || []}
                  onChange={(selected) => {
                    setFormData(prev => {
                      const updatedItems = [...prev.items];
                      updatedItems[currentParamIndex] = {
                        ...updatedItems[currentParamIndex],
                        selectedItems: selected || []
                      };
                      return { ...prev, items: updatedItems };
                    });
                  }}
                  options={itemOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  placeholder="Click here to search and select items..."
                  isSearchable={true}
                  isClearable={true}
                  closeMenuOnSelect={false}
                  menuPortalTarget={document.body}  // ✅ ADD THIS - portal the dropdown too
                  menuPosition="fixed"               // ✅ CHANGE to fixed
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '42px',
                      borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
                      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
                      '&:hover': { borderColor: '#86b7fe' }
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 999999  // ✅ Very high
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 999999  // ✅ Very high
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected 
                        ? '#0d6efd' 
                        : state.isFocused 
                        ? '#e7f1ff' 
                        : 'white',
                      color: state.isSelected ? 'white' : 'black',
                      cursor: 'pointer',
                      padding: '8px 12px'
                    })
                  }}
                  noOptionsMessage={() => {
                    if (itemOptions.length === 0) {
                      return "No items available in database";
                    }
                    return "No matching items found";
                  }}
                  loadingMessage={() => "Loading..."}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 4,
                    colors: {
                      ...theme.colors,
                      primary: '#0d6efd',
                      primary25: '#e7f1ff',
                      primary50: '#cfe2ff',
                    },
                  })}
                />
                
                <small className="text-muted d-block mt-2">
                  💡 Click the field above to see available items. Type to search.
                </small>
              </div>

              {itemOptions.length > 0 && (
                <div className="mb-3">
                  <details>
                    <summary style={{ cursor: 'pointer', color: '#0d6efd' }}>
                      View all {itemOptions.length} available items
                    </summary>
                    <div className="border rounded p-2 mt-2" style={{ maxHeight: '150px', overflowY: 'auto', fontSize: '12px' }}>
                      {itemOptions.map((opt, idx) => (
                        <div key={idx} className="p-1 border-bottom">
                          {opt.label}
                        </div>
                      ))}
                    </div>
                  </details>
                </div>
              )}

              {formData.items[currentParamIndex]?.selectedItems?.length > 0 && (
                <div className="border rounded p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  <small className="text-muted d-block mb-2"><strong>Selected Items:</strong></small>
                  {formData.items[currentParamIndex].selectedItems.map((item, idx) => (
                    <div key={idx} className="d-flex justify-content-between align-items-center mb-1 p-2 bg-light rounded">
                      <small>{item.label}</small>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setFormData(prev => {
                            const updatedItems = [...prev.items];
                            updatedItems[currentParamIndex] = {
                              ...updatedItems[currentParamIndex],
                              selectedItems: updatedItems[currentParamIndex].selectedItems.filter((_, i) => i !== idx)
                            };
                            return { ...prev, items: updatedItems };
                          });
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-light" 
            onClick={(e) => {
              e.preventDefault();
              setShowItemsModal(false);
            }}
          >
            Cancel
          </button>
          <button 
            type="button" 
            className="btn btn-success" 
            onClick={(e) => {
              e.preventDefault();
              handleSaveItems();
            }}
            disabled={itemsLoading}
          >
            Save Items
          </button>
        </div>
      </div>
    </div>
  </div>,
  document.body  // ✅ Portal target - renders directly in body
)}





</>
    
  );
}

export default AddTestParam;